import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SyncActionsOverviewComponent } from "./containers/sync-actions-overview/sync-actions-overview.component";
import { ActionTypePipe } from "./pipes/action-type.pipe";
import { SyncActionItemComponent } from "./components/sync-action-item/sync-action-item.component";
import { CachedFileItemComponent } from "./components/cached-file-item/cached-file-item.component";
import { AppEventItemComponent } from "./components/sync-event-item/sync-event-item.component";
import { ResidentToolbarModule } from "../patient/resident-toolbar";
import { TranslatePipe } from "@ngx-translate/core";
import { SharedModule } from "../shared/shared.module";
import { ActionTypeNamePipe } from "./pipes/action-type-name.pipe";

@NgModule({
	declarations: [
		SyncActionsOverviewComponent,
		ActionTypePipe,
		SyncActionItemComponent,
		CachedFileItemComponent,
		AppEventItemComponent,
		ActionTypeNamePipe,
	],
	imports: [CommonModule, ResidentToolbarModule, TranslatePipe, SharedModule],
	exports: [SyncActionsOverviewComponent],
})
export class SyncActionsModule {}
